const SET_ORIENTATION_DATA = 'SET_ORIENTATION_DATA';

export default {
  SET_ORIENTATION_DATA,
};
